/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Injector, ModuleWithProviders, NgModule } from '@angular/core';

import { AlphabetSoupAnswerService } from './services/alphabet-soup-answer.service';
import { AlphabetSoupRoundService } from './services/alphabet-soup-round.service';
import { AlphabetSoupService } from './services/alphabet-soup.service';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { BagelPhaseService } from './services/bagel-phase.service';
import { BagelQuestionService } from './services/bagel-question.service';
import { GamesService } from './services/games.service';
import { HintsService } from './services/hints.service';
import { ImagesService } from './services/images.service';
import { MemoryCellService } from './services/memory-cell.service';
import { MemoryGridService } from './services/memory-grid.service';
import { MemoryPhaseService } from './services/memory-phase.service';
import { MoneyPotService } from './services/money-pot.service';
import { PlayersService } from './services/players.service';
import { PreferencesService } from './services/preferences.service';
import { PlcHttpConfig, PlcHttpConfigToken } from './services/services.models';
import { SongClueService } from './services/song-clue.service';
import { SongPhaseService } from './services/song-phase.service';
import { UsersService } from './services/users.service';
import { ValidatorsService } from './services/validators.service';

@NgModule({
	imports: [CommonModule, HttpClientModule],
})
export class ApiModule {
	constructor(injector: Injector) {
		ApiInjector.instance = injector;
	}

	public static forRoot(
		config: PlcHttpConfig,
	): ModuleWithProviders<ApiModule> {
		return {
			ngModule: ApiModule,
			providers: [
				ApiService,
				AuthService,
				UsersService,
				PreferencesService,
				ImagesService,
				ValidatorsService,
				GamesService,
				PlayersService,
				BagelPhaseService,
				BagelQuestionService,
				MemoryPhaseService,
				MemoryGridService,
				MemoryCellService,
				SongPhaseService,
				SongClueService,
				HintsService,
				AlphabetSoupRoundService,
				AlphabetSoupService,
				AlphabetSoupAnswerService,
				MoneyPotService,
				{
					provide: PlcHttpConfigToken,
					useValue: config,
				},
			],
		};
	}
}

export class ApiInjector {
	private static _instance: Injector;
	public static get instance(): Injector {
		return ApiInjector._instance;
	}
	public static set instance(value: Injector) {
		ApiInjector._instance = value;
	}
}

export class ApiInfo {
	public static title = 'Pastalacabra API';
}
